import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"
import _imports_0 from '../../public/icons/header/color.svg'


const _hoisted_1 = {
  id: "header",
  style: {"z-index":"1000"}
}
const _hoisted_2 = {
  key: 0,
  class: "curtain"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "avatarmodal" }
const _hoisted_5 = { class: "username" }
const _hoisted_6 = {
  key: 1,
  id: "avatar",
  class: "no-outline",
  tabindex: "1"
}
const _hoisted_7 = { class: "panelButtons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_CommonButton = _resolveComponent("CommonButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "curtain" }, {
      default: _withCtx(() => [
        (_ctx.AvatarDropDownVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("img", {
      id: "logo",
      src: _ctx.appLogo
    }, null, 8, _hoisted_3),
    (_ctx.UserData!=null)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          id: "avatar",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleAvatarDropDown())),
          onFocusout: _cache[3] || (_cache[3] = ($event: any) => (_ctx.hideAvatarDropDown())),
          class: "no-outline",
          tabindex: "1"
        }, [
          _createVNode(_component_Avatar, {
            UserName: _ctx.UserData.userName,
            Initials: _ctx.UserData.initials,
            style: {"cursor":"pointer"}
          }, null, 8, ["UserName", "Initials"]),
          _createVNode(_Transition, { name: "headermodal" }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("div", _hoisted_4, [
                _createVNode(_component_Avatar, {
                  id: "bigavatar",
                  UserName: _ctx.UserData.userName,
                  Initials: _ctx.UserData.initials,
                  style: {"cursor":"pointer"},
                  Size: "large",
                  onClick: _ctx.SetOpenAvatarImageRightPanel
                }, null, 8, ["UserName", "Initials", "onClick"]),
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.UserData.name), 1),
                _cache[10] || (_cache[10] = _createElementVNode("hr", null, null, -1)),
                (!_ctx.hideFluenceHelp)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "headerbtn",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.contactSupport && _ctx.contactSupport(...args)))
                    }, [
                      _cache[8] || (_cache[8] = _createElementVNode("img", {
                        src: _imports_0,
                        style: {"visibility":"hidden"}
                      }, null, -1)),
                      _createTextVNode(_toDisplayString(_ctx.Localizer.Localize("Header_Support")), 1)
                    ]))
                  : _createCommentVNode("", true),
                _cache[11] || (_cache[11] = _createElementVNode("hr", null, null, -1)),
                _createElementVNode("div", {
                  class: "headerbtn",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.Signout_Click && _ctx.Signout_Click(...args)))
                }, [
                  _cache[9] || (_cache[9] = _createElementVNode("img", {
                    src: _imports_0,
                    style: {"visibility":"hidden"}
                  }, null, -1)),
                  _createTextVNode(_toDisplayString(_ctx.Localizer.Localize("Header_Sign_Out")), 1)
                ])
              ], 512), [
                [_vShow, _ctx.AvatarDropDownVisible]
              ])
            ]),
            _: 1
          })
        ], 32))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_Avatar, { Initials: _ctx.UserApiClientInitials }, null, 8, ["Initials"])
        ])),
    _createElementVNode("input", {
      id: "avatarImageSelector",
      ref: "avatarImageSelector",
      type: "file",
      style: {"display":"none"},
      onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.UploadUserImage && _ctx.UploadUserImage(...args))),
      accept: "image/png"
    }, null, 544),
    (_ctx.OpenAvatarImageRightPanel)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.RightPanelComponent), {
          key: 2,
          onClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.OpenAvatarImageRightPanel=false)),
          style: {"font-size":"14px","color":"var(--foreground-primary)"}
        }, {
          header: _withCtx(() => [...(_cache[12] || (_cache[12] = [
            _createElementVNode("span", { class: "title" }, "Choose Avatar Image", -1)
          ]))]),
          body: _withCtx(() => [...(_cache[13] || (_cache[13] = [
            _createElementVNode("div", null, null, -1)
          ]))]),
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_CommonButton, {
                type: _ctx.ButtonType.Default,
                text: _ctx.Localizer.Localize('Cancel_PascalCase'),
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.OpenAvatarImageRightPanel=false))
              }, null, 8, ["type", "text"]),
              _createVNode(_component_CommonButton, {
                type: _ctx.ButtonType.Primary,
                text: _ctx.Localizer.Localize('Pick_File'),
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.OpenFilePicker()))
              }, null, 8, ["type", "text"])
            ])
          ]),
          _: 1
        }, 32))
      : _createCommentVNode("", true)
  ]))
}